import Checkmark from "@/common/icons/checkmark"

export default function ErrorCircle() {
  return (
    <span className="inline-flex items-center justify-center flex-shrink-0 w-5 h-5 mr-3 bg-red-100 rounded-full color-white">
      <Checkmark className="w-2 h-2" />
    </span>
  )
}
